import { RouteConfig } from 'vue-router';

const PatientList = () => import(/* webpackChunkName: "Cdr" */  './views/patient-list/patient-list.vue');
const PatientDetail = () => import(/* webpackChunkName: "Cdr" */  './views/patient-detail/patient-detail.vue');
const DataExport = () => import(/* webpackChunkName: "Cdr" */  './views/data-export/data-export.vue');



const routers: RouteConfig[] = [
    {
        path: 'patient-list',
        component: PatientList,
        meta: {
            keepAlive: true
        }
    },
    {
        path: "patient-detail",
        component: PatientDetail,
    },
    {
        path: "data-export",
        component: DataExport
    }
];

export default routers;
